module.exports = __webpack_public_path__ + "img/group-note.56950097.svg";